import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IoIosMenu, IoIosGlobe } from "react-icons/io";

const HeaderBtn = () => {
  // State to manage the visibility of the language dropdown
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // State to manage the currently selected language
  const [currentLanguage, setCurrentLanguage] = useState("EN");

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu",
    );
    if (offcanvasMobileMenu) {
      offcanvasMobileMenu.classList.add("active");
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const changeLanguage = (lang) => {
    setCurrentLanguage(lang);
    setIsDropdownOpen(false); // Close dropdown after selection
    // Add logic here to actually change the app's language
    console.log(`Language set to: ${lang}`);
  };
  return (
    <div className="header-btn-wrapper">
      <ul className="accounts d-none d-lg-flex">
        <li>
          {/* <Link
            className="dg__bt_login btn--black btn--theme"
            to={process.env.PUBLIC_URL + "/login"}
          >
            Login
          </Link> */}

          <a
            className="dg__bt_login btn--black btn--theme"
            href="https://portal.thepips.com/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            Login
          </a>
        </li>
        <li>
          {/* <Link
            className="dg__btn__black btn--black btn--theme"
            to={process.env.PUBLIC_URL + "/register"}
          >
            Register
          </Link> */}
          <a
            className="dg__btn__black btn--black btn--theme"
            href="https://portal.thepips.com/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            Register
          </a>
        </li>
        {/* <li>
          <div className="language-selector-wrapper">
            <button
              className="language-selector-button"
              onClick={toggleDropdown}
              aria-expanded={isDropdownOpen}
            >
              <IoIosGlobe
                className="globe-icon"
              />
              <span className="lang-text ml-2">
                {currentLanguage}
              </span>
            </button>

            {isDropdownOpen && (
              <div className="language-dropdown-menu">
                <button 
                  onClick={() => changeLanguage("EN")}
                  className={currentLanguage === "EN" ? "active" : ""}
                >
                  English (EN)
                </button>
              </div>
            )}
          </div>
        </li> */}
      </ul>

      <div className="mobile-button-wrapper d-block d-xl-none text-right">
        <button className="mobile-aside-button" onClick={triggerMobileMenu}>
          <IoIosMenu />
        </button>
      </div>
    </div>
  );
};

export default HeaderBtn;
